import type { OpMeta } from '@/catalog/types'
import { api } from '@/lib/api'

export function fetchOps(): Promise<OpMeta[]> {
  return api<OpMeta[]>('/ops')
}
